export const BILLING_VIEW_ALL = "Show All";
export const BILLING_VIEW_UNPAID = "Unpaid Balance";
export const BILLING_VIEW_PAYMENTS_AID = "Payments and Aid";
